import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { from, map, Observable, switchMap } from "rxjs";
import { ADGroupResponse } from "../models/ad-group.model";
import { ADUsersResponse } from "../models/ad-user.model";
import { MsalService } from "@azure/msal-angular";
import { AuthenticationResult } from "@azure/msal-browser";

@Injectable({
  providedIn: "root",
})
export class MsalApiService {
  constructor(
    private _http: HttpClient,
    private readonly msalService: MsalService
  ) {}

  getADUserProfilePicture(): Observable<Blob> {
    const requestUrl = `${environment.msal.graphUrl}/me/photo/$value`;
    return this._http.get(requestUrl, { responseType: "blob" }).pipe(
      map((res: Blob) => {
        return res;
      })
    );
  }

  getADUsers(): Observable<ADUsersResponse> {
    const requestUrl = `${environment.msal.graphUrl}/users`;
    return this._http.get<ADUsersResponse>(requestUrl);
  }

  getDataUsingODataLink(url: string): Observable<ADUsersResponse> {
    return this._http.get<ADUsersResponse>(url).pipe(
      map((result: ADUsersResponse) => {
        return result;
      })
    );
  }

  getFilteredUsers(params: string): Observable<ADUsersResponse> {
    const requestUrl = `${environment.msal.graphUrl}/users${params}`;
    return this._http.get<ADUsersResponse>(requestUrl).pipe(
      map((result: ADUsersResponse) => {
        return result;
      })
    );
  }

  getADUserGroups(id: string): Observable<ADGroupResponse> {
    const requestUrl = `${environment.msal.graphUrl}/users/${id}/memberOf`;
    return this._http.get<ADGroupResponse>(requestUrl);
  }

  sendMail(payload: unknown): Observable<unknown> {
    const requestUrl = `${environment.msal.graphUrl}/me/sendMail`;
    return this._http.post(requestUrl, payload);
  }

  getUserProfilePicture(loginEmail: string): Observable<Blob> {
    const requestUrl = `${environment.msal.graphUrl}/users/${loginEmail}/photo/$value`;
    return this._http.get(requestUrl, { responseType: "blob" }).pipe(
      map((res: Blob) => {
        return res;
      })
    );
  }

  getAndSyncUserMails() {
    const account = this.msalService.instance.getActiveAccount();

    return from(
      this.msalService.instance.acquireTokenSilent({
        account: account!,
        scopes: ["Directory.Read.All"],
      })
    ).pipe(
      switchMap((result: AuthenticationResult) => {
        const headers = new HttpHeaders({
          "Graph-Token": result.accessToken,
        });

        // Authorization header for your API is still added automatically
        // by the MSAL interceptor.

        return this._http.get(
          `https://localhost:7220/api/user/GetAndSyncUserMails`,
          { headers }
        );
      })
    );
  }
}
